import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Optional,
  Self,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl, UntypedFormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { InputTextComponent } from '@shared/components/form-elements/input-text/input-text.component';

@UntilDestroy()
@Component({
  selector: 'app-bui-search',
  templateUrl: './bui-search.component.html',
  styleUrls: ['./bui-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class BuiSearchComponent implements OnInit, OnChanges, ControlValueAccessor {
  @Input() placeholder: string | 'COMMON.SEARCH' = 'COMMON.SEARCH';
  @Input() autocomplete: 'on' | 'off' = 'off';
  @Input() isFullWide = true;

  @ViewChild(InputTextComponent) inputTextComponent: InputTextComponent;

  formControl: UntypedFormControl;
  clearButtonIsVisible = false;

  constructor(@Self() @Optional() public ngControl: NgControl,
              private elementRef: ElementRef) {
    if (ngControl) {
      ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    this.formControl = this.ngControl.control as FormControl;

    this.formControl.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe(val => {
        this.clearButtonIsVisible = !!val;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isFullWide) {
      if (this.isFullWide) {
        this.elementRef.nativeElement.classList.add('app-bui-search--full-wide');
      } else {
        this.elementRef.nativeElement.classList.remove('app-bui-search--full-wide');
      }
    }
  }

  registerOnChange(fn: any): void {
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(obj: any): void {
  }

  clear(): void {
    this.inputTextComponent.clear();
  }
}
